exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-text{visibility:hidden;position:fixed;width:750px;color:#fff;font-size:12px;background-color:#192733;border-radius:10px;padding:10px 15px;z-index:3}.tooltip-text:before{content:\"\";position:absolute;-webkit-transform:rotate(45deg);transform:rotate(45deg);background-color:#192733;z-index:1}.hover-text:hover .tooltip-text{visibility:visible}#top{top:30%;left:30%}#top:before{top:80%;left:45%}#down{top:30%;left:30%}#down:before{top:80%;left:45%}.hover-text{position:absolute;display:inline-block;font-family:Arial;text-align:left}ul.no-bullets{list-style-type:none;margin:0;padding:0}.import-modal .modal-body{max-height:90vh}.import-modal .modal-dialog{max-width:60vw}.rate-success{color:#00b050}.rate-danger{color:#dc3545}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-878f2552","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/Orders/ShowImportModal.vue
// module id = 6qV5
// module chunks = 1